import React from 'react';
import { CloseButtonStyle } from './CloseButton.styles';
import { X } from 'lucide-react';
import { useIntl } from 'react-intl';

interface CloseButtonProps {
  onClick: () => void;
}

export const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => (
  <CloseButtonStyle
    onClick={onClick}
    aria-label={useIntl().formatMessage({ id: "close" })}
    title={useIntl().formatMessage({ id: "close" })}
    >
    <X size={18} strokeWidth={2.5} />
  </CloseButtonStyle>
);